import { IonPage, IonButton, IonCardContent, IonContent, IonInput, IonItem, IonCard, IonAlert, useIonViewDidEnter } from '@ionic/react';
import React, { useState } from 'react';
import { withRouter } from "react-router-dom";
import axios from 'axios';
import Navbar from '../../components/Navbar';
import { ServerUrl } from '../../constants';
import './Auth.css';
import { VerifyPassword } from '../../constants';

const ResetPassword: React.FC = (props: any) => {
  const [email, setEmail] = useState<string>();
  const [code, setCode] = useState<string>();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>();
  const [messageAlert, showMessageAlert] = useState<boolean>(false);

  const onResetPassword = ()=> {
      let msg = '';
      if (!email) msg += 'Email is empty. ';
      if (!code) msg += 'Code is empty. ';
      if (!password) msg += 'Password is empty. ';
      if (!confirmPassword) msg += 'Confirm Password is empty. ';
      if (password !== confirmPassword) msg += `Password doesn't match confirm password. `;

      if (!VerifyPassword(password)) {
        msg += 'Password must contain at least one numeric digit and a special character, and has more than 7 characters.';
      }

      if (msg.length > 0) {
        setErrorMessage(msg);
        showMessageAlert(true);
        return;
      }

      axios.post(`${ServerUrl}/Auth/resetpassword`, {email, password, code}).then(res => {
        alert("Your password is changed.");
        props.history.push("/signin");
      }).catch(err => {
        alert(err);
      });
  };

  useIonViewDidEnter(() => {
    let paras = window.location.search.slice(1, window.location.search.length).split('&');
    paras.forEach(element => {
      let items = element.split('=');
      if (items.length === 2) {
        if (items[0] === 'email') setEmail(items[1]);
        else if (items[0] === 'code') setCode(items[1]);
      }
    })
  });

  return(
      <IonPage>
          <Navbar />
          <IonContent>
          <IonAlert 
              isOpen={messageAlert}
              onDidDismiss={()=> showMessageAlert(false)}
              header={'Error'}
              subHeader={''}
              message={errorMessage}
              buttons={['OK']}
          />
          <div className='Container'>
            <div className='PageTitle'>Reset Password</div>
            <IonCard>
              <IonCardContent>
                <IonItem className="TextInput">
                    <IonInput min='0'  type="password" value={password} placeholder="Password" 
                        onIonChange={e => setPassword(e.detail.value!)}>
                    </IonInput>
                </IonItem >
                <IonItem className="TextInput">
                    <IonInput min='0'  type="password" value={confirmPassword} placeholder="Confirm Password" 
                        onIonChange={e => setConfirmPassword(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <div className='RowCenter'>
                  <IonButton color="primary" style={{textTransform:'none'}} onClick = {onResetPassword}>Reset</IonButton>
                </div>
              </IonCardContent>
            </IonCard>
          </div>
          </IonContent>
      </IonPage>
  );
};

export default withRouter(ResetPassword);
